type Props = {
  id: 'purple-green' | 'magenta-yellow';
};

function getColorInterpolationFilter(id: Props['id']) {
  switch (id) {
    case 'purple-green': {
      return (
        <>
          <feFuncR type="table" tableValues="0.650980392157 0.403921568627" />
          <feFuncG type="table" tableValues="0 1" />
          <feFuncB type="table" tableValues="0.447058823529 0.4" />
          <feFuncA type="table" tableValues="1 1" />
        </>
      );
    }
    case 'magenta-yellow':
    default: {
      return (
        <>
          <feFuncR type="table" tableValues="0.780392156863 1" />
          <feFuncG type="table" tableValues="0 0.949019607843" />
          <feFuncB type="table" tableValues="0.352941176471 0.470588235294" />
          <feFuncA type="table" tableValues="1 1" />
        </>
      );
    }
  }
}

const SvgWpDuotone = ({ id }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
      width="0"
      height="0"
      focusable="false"
      role="none"
      style={{
        visibility: 'hidden',
        position: 'absolute',
        left: '-9999px',
        overflow: 'hidden',
      }}
    >
      <defs>
        <filter id={`wp-duotone-${id}`}>
          <feColorMatrix
            colorInterpolationFilters="sRGB"
            type="matrix"
            values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          />
          <feComponentTransfer colorInterpolationFilters="sRGB">
            {getColorInterpolationFilter(id)}
          </feComponentTransfer>
          <feComposite in2="SourceGraphic" operator="in" />
        </filter>
      </defs>
    </svg>
  );
};

export { SvgWpDuotone };
